export function countTrueValues(obj) {
  let count = 0;
  
  function traverse(current) {
    if (typeof current !== 'object' || current === null) {
      return;
    }
    
    for (const key in current) {
      if (current.hasOwnProperty(key)) {
        const value = current[key];
        
        if (value === true) {
          count++;
        } else if (typeof value === 'object' && value !== null) {
          traverse(value); // Рекурсивный обход вложенных объектов
        }
      }
    }
  }
  
  traverse(obj);
  return count;
}

export function clearAllFields(obj) {

    const newObj = JSON.parse(JSON.stringify(obj));


    function traverse(current) {
        if (typeof current !== 'object' || current === null) {
            return;
        }
        
        for (const key in current) {
        if (current.hasOwnProperty(key)) {
            const value = current[key];
            
            if (value === true) {
                current[key] = false;
            } else if (typeof value === 'object' && value !== null) {
            traverse(value); // Рекурсивный обход вложенных объектов
            }
        }
        }
    }

    traverse(newObj);

    return newObj;

}